/** React Query keys of a member's dashboard visibility (Access tab). */
export const memberDashboardVisibilityQueryKeys = {
  all: ["member-dashboard-visibility"] as const,
  detail: (customerId: string) =>
    ["member-dashboard-visibility", customerId] as const,
};
